module.exports = __webpack_public_path__ + "img/photo-0018.d145e67c.jpg";